<template>

  <!--========================================


  ---------------------------------------------
  TABLE_OF_CONTENTS_OF_HTML_TEMPLATE
  ---------------------------------------------
  1. HEADER_SECTION
  2. AGREEMENT_SECTION
  2.1 FILTERS_SECTION
  3. INVOICES_SECTION
  4. MODALS_SECTION
  5. TIMELINE_SECTION 
  ---------------------------------------------




  ---------------------------------------------
  TABLE_OF_CONTENTS_OF_JS_SCRIPT
  ---------------------------------------------
  1. PRIMARY_DATA
  2. SETTERS_AND_GETTERS
  3. CALCULATE_SUM_WATCHERS
  4. PRIMARY_INITIALIZATION
  5. VIEW_AND_EDIT_MODES
  6. REFRESH_TIMELINE
  7. REFRESH
  8. CALCULATE_SUM
  9. DISABLE_STATUS_IF_NEEDED
  10. SHOW_MODALS
  11. OTHERS
  ---------------------------------------------



  ========================================-->



  <div>
    <div>
      <b-card>



        <!--  ==============================  HEADER_SECTION START ============================== -->
        <b-row class="align-items-center">
          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">
                {{ $t("application_number") }}
              </h6>
              <small>#{{ GET_ONE_CONTRACT.id }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">
                {{ $t("date") }}
              </h6>
              <small>{{ $dayjs(GET_ONE_CONTRACT.created_at).format("DD.MM.YYYY") }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">
                {{ $t("author") }}
              </h6>
              <div class="d-flex">
                <small
                  v-if="
                    GET_ONE_CONTRACT.author &&
                    GET_ONE_CONTRACT.author.first_name
                  "
                  >{{ GET_ONE_CONTRACT.author.first_name }}</small
                >
                <small v-if="GET_ONE_CONTRACT.author" class="ml-50">{{
                  GET_ONE_CONTRACT.author.last_name
                }}</small>
              </div>
            </div>
          </b-col>

          <b-col class="col-md-3">
            <div class="flex_column align-items-center">
              <h6 class="font-weight-bolder">
                {{ $t("status") }}
              </h6>
              <b-badge
                v-if="GET_ONE_CONTRACT.status"
                :variant="GET_ONE_CONTRACT.status.color"
              >
                {{ GET_ONE_CONTRACT.status.name }}
              </b-badge>
            </div>
          </b-col>
        </b-row>
        <!--  ==============================  HEADER_SECTION END ============================== -->






      </b-card>
      <b-row>
        <b-col>
          <b-card>
            <validation-observer ref="contractValidations">
              <b-tabs>





                <!--  ==============================  AGREEMENT_SECTION START ============================== -->
                <b-tab active :title="$t('agreement')">
                  <div class="top">
                    <div
                      class="d-flex align-items-center justify-content-between flex-wrap"
                    >
                      <div class="d-flex">

                        <b-form-group :label="$t('agreement')">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('agreement')"
                            rules="required"
                          >
                            <b-form-input
                              v-model="contract.contract_number"
                              :placeholder="$t('agreement')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('date')" class="ml-1">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('date')"
                            rules="required"
                          >
                            <VueDataPicker
                              class="date-dark"
                              v-model="contract.date"
                              placeholder="YYYY-MM-DD"
                              :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('provider')" class="ml-1">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('provider')"
                            rules="required"
                          >
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model="seller"
                                class="input__radius"
                                disabled
                              />
                              <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                v-b-modal.suppliers-modal
                                class="choose-btn"
                                style="min-width: 225px"
                                variant="primary"
                              >
                                <feather-icon
                                  class="mr-50"
                                  icon="AlignJustifyIcon"
                                  size="16"
                                />
                                {{ $t("select_from_registry") }}
                              </b-button>
                            </div>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('buyer')" class="">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('buyer')"
                            rules="required"
                          >
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model="buyer"
                                class="input__radius"
                                disabled
                              />
                              <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                v-b-modal.buyers-modal
                                class="choose-btn"
                                style="min-width: 225px"
                                variant="primary"
                              >
                                <feather-icon
                                  class="mr-50"
                                  icon="AlignJustifyIcon"
                                  size="16"
                                />
                                {{ $t("select_from_registry") }}
                              </b-button>
                            </div>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                      </div>
                      <div class="d-flex">
                        <b-button
                          v-if="checkButtonPermission(['supplier', 'chief_supplier', 'accountant', 'chief_manager', 'admin'])"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          size="sm"
                          class="d-flex align-items-center ml-50"
                          variant="success"
                          @click="showModalAddFiles()"
                          :disabled="!isMounted"
                        >
                          <!-- @click="deleteApp(data)" -->
                          <feather-icon
                            icon="EyeIcon"
                            size="18"
                            class="mr-50"
                          />
                          {{$t('watch_files')}}
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-3 mb-2" />
                  <b-row>
                    <b-col class="col-md-12 text-center mb-1">
                      <h2>{{ $t("based_on_applications") }}</h2>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-end">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="outline-primary"
                        @click="openModalBasedOnApplication()"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        {{ $t("add") }}
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <BasedOnAplicationForEdit />
                    </b-col>
                  </b-row>

                  <b-row class="treaty mt-2">
                    <b-col md="12" class="mb-2 text-center">
                      <h2>{{ $t("subject_of_the_contract") }}</h2>
                    </b-col>

                    <b-col class="col-md-12 mb-3">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h4 class="mb-0">
                          {{ $t("reference.material") }}
                        </h4>

                      </div>
                      <MaterialsTableForEdit />
                    </b-col>
                    <b-col class="col-md-12 mb-2">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h4 class="mb-0">
                          {{ $t("reference.instrument") }}
                        </h4>

                      </div>
                      <InstrumentsTableForEdit />
                    </b-col>
                  </b-row>

                  <b-row class="sum mt-2">
                    <b-col class="col-md-12 text-center mb-1">
                      <h2>{{ $t("аmount_of_contract_and_invoice") }}</h2>
                    </b-col>
                    <b-col md="2">
                      <span
                        >{{ $t("total_amount") }}:&nbsp;{{
                          contract.total_sum
                        }}</span
                      >
                    </b-col>
                  </b-row>

                  <hr class="mt-1" />

                  <div class="text-right mt-3">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class=""
                      variant="secondary"
                      @click="$router.push('/agreements')"
                    >
                      {{ $t("general.cancel") }}
                    </b-button>

                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class="ml-2"
                      variant="primary"
                      @click="onSaveContract"
                    >
                      {{ $t("save") }}
                    </b-button>
                  </div>
                </b-tab>
              </b-tabs>
            </validation-observer>

            <AddContractInvoiceModal
              @refreshPage="refresh()"
            ></AddContractInvoiceModal>
            <BasedOnApplicationsModalForEdit></BasedOnApplicationsModalForEdit>
            <SuppliersModal @input="companyInput" />
            <BuyersModal @input="buyerCompanyInput" />
            <modalUniversal :type="type" />
          </b-card>
        </b-col>

        <b-col cols="3" v-if="$route.params.id != 'new'">
          <b-card>
            <div class="d-flex flex-wrap">
              <app-timeline class="h-100 w-100">
                <app-timeline-item
                  v-for="item in GET_APPLICATION_STATUS_TIMELINE_BY_ID"
                  :key="item.id"
                  :title="item.to_status.full_name + ' #' + item.object_id"
                  :subtitle="item.author.first_name + item.author.last_name"
                  :comment="(item.description ? item.description : '')"
                  :icon="item.to_status.icon"
                  :time="$dayjs(item.created_at).format('DD.MM.YYYY, HH:mm')"
                  :variant="item.to_status.color"
                  :author="true"
                >
                </app-timeline-item>
              </app-timeline>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <addFilesModal1 :type="addFilestype"/>

  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BCard,
  BTabs,
  BTab,
  BBadge,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Ripple from "vue-ripple-directive";

import MaterialsTableForEdit from "./components/tables/materialsTableForEdit.vue";
import InstrumentsTableForEdit from "./components/tables/instrumentsTableForEdit.vue";
import InvoicesTable from "./components/tables/invoicesTable.vue";

import BasedOnAplicationForEdit from "./components/tables/BasedOnAplicationForEdit.vue";

import SuppliersModal from "./components/modals/suppliersModal.vue";
import BuyersModal from "./components/modals/buyersModal.vue";
import modalUniversal from "./components/modals/modalMaterialInstrument.vue";
import BasedOnApplicationsModalForEdit from "./components/modals/BasedOnApplicationsModalForEdit.vue";
import AddContractInvoiceModal from "./components/modals/addContractInvoiceModal.vue";

import VueDataPicker from "@/components/VueDatePicker.vue";
import objective from "@/mixins/objective";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import addFilesModal1 from './components/modals/addFilesModal1.vue'

import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCard,
    BTabs,
    BTab,
    BBadge,

    MaterialsTableForEdit,
    InstrumentsTableForEdit,
    InvoicesTable,
    SuppliersModal,
    BuyersModal,

    VueDataPicker,

    modalUniversal,
    BasedOnAplicationForEdit,
    BasedOnApplicationsModalForEdit,
    AddContractInvoiceModal,

    ValidationObserver,
    ValidationProvider,

    addFilesModal1,

    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    Ripple,
  },
  mixins: [objective, check, loader, priceFormatMixin],
  data() {
    return {




      // =============== PRIMARY_DATA START ===============
      type: true,
      seller: null,
      buyer: null,
      addFilestype: 'add',
      isMounted: false,
      // =============== PRIMARY_DATA END ===============





    };
  },
  computed: {
    ...mapGetters("agrements", ["GET_ONE_CONTRACT"]),
    ...mapGetters("application", [
      "GET_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),







    // ========================= SETTERS_AND_GETTERS START =========================
    contract: {
      get: function () {
        return this.$store.state.agrements.contract;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_CONTRACT", newValue);
      },
    },
    materialItemsForEdit: {
      get: function () {
        return this.$store.state.agrements.materialItemsForEdit;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_MATERIAL_ITEMS_FOR_EDIT", newValue);
      },
    },
    instrumentItemsForEdit: {
      get: function () {
        return this.$store.state.agrements.instrumentItemsForEdit;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_INSTRUMENT_ITEMS_FOR_EDIT", newValue);
      },
    },
    viewMode: {
      get: function () {
        return this.$store.state.agrements.viewMode;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_VIEW_MODE", newValue);
      },
    },
    materialAndInstrumentApplicationsForEdit: {
      get: function () {
        return this.$store.state.agrements.materialAndInstrumentApplicationsForEdit;
      },
      set: function (newValue) {
        this.$store.commit(
          "agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS_FOR_EDIT",
          newValue
        );
      },
    },
    refreshAgreement: {
      get: function () {
        return this.$store.state.agrements.refreshAgreement;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_REFRESH_AGREEMENT", newValue);
      },
    },
    contractFiles: {
      get: function () {
        return this.$store.state.agrements.contractFiles;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CONTRACT_FILES', newValue)
      }
    },
    // ========================= SETTERS_AND_GETTERS END =========================






  },
  watch: {





    // ========================= CALCULATE_SUM_WATCHERS START =========================
    materialItemsForEdit: {
      deep: true,
      handler(newValue) {
        this.calculateSum();
      },
    },
    instrumentItemsForEdit: {
      deep: true,
      handler(newValue) {
        this.calculateSum();
      },
    },
    async refreshAgreement(newValue) {
      if (newValue) {
        await this.refresh();
        this.refreshAgreement = false;
      }
    },

    materialAndInstrumentApplicationsForEdit: {
      deep: true,
      handler(newValue) {
        if (true) {


          let materials = [];
          let instruments = [];




           newValue.forEach((elem) => {
             
             
              this.GET_ONE_CONTRACT.goods.forEach((elem3) => {

                if(elem3.requirement_id != elem.id){
                  
                  if (elem.goods) {
      
                    let goodsNew = elem.goods.map((item) => ({
                      requirement_id: elem.id,
                      id: null,
                      product: item?.good?.product?.title,
                      good: item.good,
                      count: item.count,
                      responsible: item.responsible,
                      price: item.price,
                    }));
      
               
      
                    goodsNew.forEach((item1) => {
                      if(this.materialItemsForEdit.length > 0){
                        this.materialItemsForEdit.forEach((item2) => {
                          if(item2.good.id != item1.good.id){
                            materials.push(item1);
                          }
                        })
                      }else{
                        materials.push(item1);
                      }
                    });
      
                  }else if (elem.instruments) {
      
                    let instrumentsNew = elem.instruments.map((item) => ({
                      requirement_id: elem.id,
                      id: null,
                      product: item?.instrument?.type?.title,
                      instrument: item.instrument,
                      count: item.count,
                      responsible: item.responsible,
                      price: item.price,
                    }));
      
                   
      
                    instrumentsNew.forEach((item1) => {
                      if(this.instrumentItemsForEdit.length > 0){
                        this.instrumentItemsForEdit.forEach((item2) => {
                          if(item2.instrument.id != item1.instrument.id){
                            instruments.push(item1);
                          }
                        })
                      }else{
                        instruments.push(item1);
                      }
                    });
                  }

                }
              })



              if(this.GET_ONE_CONTRACT.goods.length == 0){
                
                  if (elem.goods) {
      
                    let goodsNew = elem.goods.map((item) => ({
                      requirement_id: elem.id,
                      id: null,
                      product: item?.good?.product?.title,
                      good: item.good,
                      count: item.count,
                      responsible: item.responsible,
                      price: item.price,
                    }));
      
               
      
                    goodsNew.forEach((item1) => {
                      if(this.materialItemsForEdit.length > 0){
                        this.materialItemsForEdit.forEach((item2) => {
                          if(item2.good.id != item1.good.id){
                            materials.push(item1);
                          }
                        })
                      }else{
                        materials.push(item1);
                      }
                    });
      
                  }else if (elem.instruments) {
      
                    let instrumentsNew = elem.instruments.map((item) => ({
                      requirement_id: elem.id,
                      id: null,
                      product: item?.instrument?.type?.title,
                      instrument: item.instrument,
                      count: item.count,
                      responsible: item.responsible,
                      price: item.price,
                    }));
      
                   
      
                    instrumentsNew.forEach((item1) => {
                      if(this.instrumentItemsForEdit.length > 0){
                        this.instrumentItemsForEdit.forEach((item2) => {
                          if(item2.instrument.id != item1.instrument.id){
                            instruments.push(item1);
                          }
                        })
                      }else{
                        instruments.push(item1);
                      }
                    });
                  }

              }



          });





          this.materialItemsForEdit = this.materialItemsForEdit.concat(materials);
          this.instrumentItemsForEdit = this.instrumentItemsForEdit.concat(instruments);



          // ==================== Removing duplicate materials and instruments ====================
          this.materialItemsForEdit = this.materialItemsForEdit.reduce((accumulator, current) => {
            if (!accumulator.find((item) => item.good.id === current.good.id)) {
              accumulator.push(current);
            }
            return accumulator;
          }, []);
          this.instrumentItemsForEdit = this.instrumentItemsForEdit.reduce((accumulator, current) => {
            if (!accumulator.find((item) => item.instrument.id === current.instrument.id)) {
              accumulator.push(current);
            }
            return accumulator;
          }, []);
          // ==================== Removing duplicate materials and instruments ====================





          this.materialItemsForEdit = this.materialItemsForEdit.filter(
            (elem) => elem.count != 0
          );
          this.instrumentItemsForEdit = this.instrumentItemsForEdit.filter(
            (elem) => elem.count != 0
          );
        }
      },
    },




    // ========================= CALCULATE_SUM_WATCHERS END =========================
  },
  async created(){





    // ========================= PRIMARY_INITIALIZATION START =========================
    this.contract.type_contract = true
    this.contract.contract_number = null
    this.contract.seller = null
    this.contract.buyer = null
    this.contract.goods = []
    this.contract.instrument = []
    this.contract.date = null
    this.contract.total_sum = null
    
    this.seller = null
    this.buyer = null
    this.addFilestype = 'add',
    this.type = true

    this.materialAndInstrumentApplicationsForEdit = []
    this.materialItemsForEdit = []
    this.instrumentItemsForEdit = []
    this.contractFiles = []

    this.viewMode = false
    // ========================= PRIMARY_INITIALIZATION END =========================






  },
  async mounted() {
    await this.$_loaderStart();




    // ========================= VIEW_AND_EDIT_MODES START =========================
    await this.refresh();
    await this.refreshTimeline()

    this.isMounted = true
    // ========================= VIEW_AND_EDIT_MODES END =========================




  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
  methods: {
    ...mapActions("agrements", [
      "UPDATE_CONTRACTS_LIST",
      "UPDATE_PATCH_CONTRACTS_LIST",
      "FETCH_ONE_CONTRACTS",
    ]),
    ...mapActions("application", [
      "FETCH_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),






    // ========================= REFRESH_TIMILINE START =========================
    async refreshTimeline() {
      await this.FETCH_APPLICATION_STATUS_TIMELINE_BY_ID({
        id: this.$route.params.id,
        params: {
          content_type_model: "contracts",
          object_id: this.$route.params.id,
        },
      });
    },
    // ========================= REFRESH_TIMILINE END =========================







    // ========================= REFRESH START =========================
    async refresh() {
      await this.FETCH_ONE_CONTRACTS(this.$route.params.id)
        .then(() => {
          const {
            id,
            contract_number,
            amount,
            seller,
            buyer,
            files,
            instruments,
            goods,
            invoice,
            created_at,
            requirement_goods,
            requirement_instruments,
            // eslint-disable-next-line no-unused-vars
          } = this.GET_ONE_CONTRACT;
          this.contract = {
            id,
            contract_number,
            total_sum: amount,
            seller: seller?.id,
            buyer: buyer.id,
            date: created_at,
          };


          this.materialItemsForEdit = goods.map((item) => ({
            requirement_id: item.requirement_id,
            id: item.id,
            product: item?.good?.product?.title,
            good: item.good,
            count: item.count,
            responsible: item.responsible,
            price: item.price,
          }));

          this.instrumentItemsForEdit = instruments.map((item) => ({
            requirement_id: item.requirement_id,
            id: item.id,
            product: item?.instrument?.type?.title,
            instrument: item.instrument,
            count: item.count,
            responsible: item.responsible,
            price: item.price,
          }));

          this.invoiceItems = invoice;
          this.contractFiles = files;

          this.invoiceItems.forEach((elem) => {
            elem.goods.forEach((item) => {
              item.count = this.$_formatPriceMixin(item.quantity);
            });
            elem.instruments.forEach((item) => {
              item.count = this.$_formatPriceMixin(item.quantity);
            });
          });

          this.materialAndInstrumentApplicationsForEdit = requirement_goods.concat(
            requirement_instruments
          );

          this.seller = seller.company_name;
          this.buyer = buyer.company_name;
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.$router.push("/agreements");
          }
        });
    },
    
    
    
    
    
    async refreshPage(event) {
      await this.refresh();
      await this.refreshTimeline()
    },
    // ========================= REFRESH END =========================











    // ===============  SEARCH_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "total_sum") {
          this.contract.total_sum = currency;
        } else if (type == "currency") {
          return currency;
        }
      }
      return 0;
    },
    // ===============  SEARCH_SECTION END ===============










    // ========================= CALCULATE_SUM START =========================
    calculateSum() {
      this.$set(this.contract, "total_sum", 0);
      this.materialItemsForEdit.forEach((item) => {
        item.count = this.formatPrice(item.count, "currency");
        item.price = this.formatPrice(item.price, "currency");
        if (item.count && item.price) {
          this.contract.total_sum +=
            item.count.toString().replace(/,/g, "") *
            item.price.toString().replace(/,/g, "");
        }
      });
      this.instrumentItemsForEdit.forEach((item) => {
        item.count = this.formatPrice(item.count, "currency");
        item.price = this.formatPrice(item.price, "currency");
        if (item.count && item.price) {
          this.contract.total_sum +=
            item.count.toString().replace(/,/g, "") *
            item.price.toString().replace(/,/g, "");
        }
      });

      this.formatPrice(this.contract.total_sum, "total_sum");
    },
    // ========================= CALCULATE_SUM END =========================









    // ========================= DISABLE_STATUS_IF_NEEDED START =========================
    disableStatusIfNeeded() {
      let status = true;
      let countNeeded = 0;
      let countExist = 0;

      if (this.GET_ONE_CONTRACT.status.unique_name != "paid_contract") {
        status = false;
      }

      this.GET_ONE_CONTRACT.goods.forEach((elem) => {
        countNeeded = countNeeded + elem.count;
      });
      this.GET_ONE_CONTRACT.instruments.forEach((elem) => {
        countNeeded = countNeeded + elem.count;
      });

      this.GET_ONE_CONTRACT.invoice.forEach((elem) => {
        if (elem.status.unique_name == "accepted_invoice") {
          elem.goods.forEach((item) => {
            countExist = countExist + item.quantity;
          });
          elem.instruments.forEach((item) => {
            countExist = countExist + item.quantity;
          });
        }
      });

      if (countExist == countNeeded) {
        status = false;
      }

      return status;
    },
    // ========================= DISABLE_STATUS_IF_NEEDED END =========================














    // ========================= ON_SAVE_CONTRACT START =========================
    async onSaveContract() {
      const isValid = await this.$refs.contractValidations.validate();
      if (isValid) {
        const data = {
          // date: this.contract.date,
          date: this.$dayjs(new Date()).format('YYYY-MM-DD'),
          seller: this.contract.seller,
          buyer: this.contract.buyer,
          goods: [],
          instruments: [],
          requirement_goods: [],
          requirement_instruments: [],
          contract_number: this.contract.contract_number,
          amount: this.contract.total_sum.toString().replace(/,/g, ""),
          type_contract: true,
        };

        this.materialAndInstrumentApplicationsForEdit.forEach((elem) => {
          if (elem && elem.goods) {
            data.requirement_goods.push(elem.id);
          }
          if (elem && elem.instruments) {
            data.requirement_instruments.push(elem.id);
          }
        });
        
        this.materialItemsForEdit.forEach((elem) => {
          data.goods.push({
            id: elem.id,
            requirement_id: elem.requirement_id,
            good_id: elem.good.id,
            count: parseFloat(elem.count.toString().replace(/,/g, "")),
            price: parseFloat(elem.price.toString().replace(/,/g, "")),
          });
        });

        this.instrumentItemsForEdit.forEach((elem) => {
          data.instruments.push({
            id: elem.id,
            requirement_id: elem.requirement_id,
            instrument_id: elem.instrument.id,
            count: parseFloat(elem.count.toString().replace(/,/g, "")),
            price: parseFloat(elem.price.toString().replace(/,/g, "")),
          });
        });


        let formData = new FormData()
        this.contractFiles.forEach((elem) => {formData.append('files', elem.url)})

        formData.append("created_at", data.date);
        formData.append("seller", data.seller);
        formData.append("buyer", data.buyer);
        formData.append("goods", JSON.stringify(data.goods));
        formData.append("instruments", JSON.stringify(data.instruments));
        formData.append("requirement_goods",  JSON.stringify(data.requirement_goods));
        formData.append("requirement_instruments",  JSON.stringify(data.requirement_instruments));
        formData.append("contract_number", data.contract_number);
        formData.append("amount", data.amount);
        formData.append("type_contract", data.type_contract);

        if (this.materialItemsForEdit.length == 0 && this.instrumentItemsForEdit.length == 0) {
          this.$_errToast({ message: this.$t('supply_of_materials_and_tools') });
        } else {
          this.UPDATE_CONTRACTS_LIST({
            data: data,
            id: this.$route.params.id,
          })
            .then(() => {
              this.$router.push("/agreements");
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      } else {
        this.$_errToast({ message: this.$t("general.no_valid") });
      }
    },
    // ========================= ON_SAVE_CONTRACT END =========================



















    // ========================= SHOW_MODALS END =========================
    openModal(type) {
      this.type = type;
      this.$bvModal.show("modalUniversal");
    },
    openModalBasedOnApplication() {
      this.$bvModal.show("BasedOnAplicationForEdit");
    },
    showModalAddFiles(id){
      this.addFilestype = 'show'
      this.$bvModal.show('addFilesModal1')
    },
    // ========================= SHOW_MODALS END =========================



















    // ========================= OTHERS START =========================
    companyInput(e) {
      this.seller = e.company_name;
      this.$set(this.contract, "seller", e.id);
    },
    buyerCompanyInput(e) {
      this.buyer = e.company_name;
      this.$set(this.contract, "buyer", e.id);
    },
    // ========================= OTHERS END =========================






    
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.dark-layout .date-dark input {
  background-color: #283046 !important;
}

.repeater-form {
  transition: 0.35s height;
}

.choose-btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  display: flex;
  align-items: center;
}

.input__radius {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  min-width: 300px;
}
</style>
